"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urijs = _interopRequireDefault(require("urijs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Assets = require("./Assets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  height: auto;\n  padding: 2px;\n\n  &:hover {\n    border: 1px solid orange;\n    background: lightgoldenrodyellow;\n    cursor: pointer;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  width: 10%;\n  max-width: 44px;\n  line-height: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var loadIcon = function loadIcon(view, selectedView) {
  return require("./img/".concat(view, ".").concat(view === selectedView ? "" : "un", "selected.png"));
};

var resolve = function resolve(uri, baseUrl) {
  return (0, _urijs["default"])(uri).is("absolute") ? (0, _urijs["default"])(uri) : (0, _urijs["default"])(uri, baseUrl);
};

var IconWrapperDiv = _styledComponents["default"].div(_templateObject());

var IconImg = _styledComponents["default"].img(_templateObject2());

var Switcher = function Switcher(_ref) {
  var atlasUrl = _ref.atlasUrl,
      species = _ref.species,
      selectedView = _ref.selectedView,
      onChangeView = _ref.onChangeView;
  return _react["default"].createElement(IconWrapperDiv, null, (0, _Assets.getAnatomogramViews)(species).map(function (view) {
    return _react["default"].createElement(IconImg, {
      key: view,
      onClick: function onClick() {
        return onChangeView(view);
      },
      src: resolve(loadIcon(view, selectedView), atlasUrl).toString()
    });
  }));
};

Switcher.propTypes = {
  atlasUrl: _propTypes["default"].string.isRequired,
  species: _propTypes["default"].string.isRequired,
  selectedView: _propTypes["default"].string,
  onChangeView: _propTypes["default"].func.isRequired
};
Switcher.defaultProps = {
  atlasUrl: "https://www.ebi.ac.uk/gxa/"
};
var _default = Switcher;
exports["default"] = _default;